import { render } from "./FormChecksRadios.vue?vue&type=template&id=5766becc"
import script from "./FormChecksRadios.vue?vue&type=script&lang=js"
export * from "./FormChecksRadios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__